import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/tg.ts
var add = "Илова кардан";
var remove = "Хориҷ кардан";
var removeAll = "Ҳамаро хориҷ кунед";
var incomplete = "Бубахшед, на ҳама майдонҳо дуруст пур карда шудаанд.";
var submit = "Пешниҳод кунед";
var noFiles = "Ягон файл интихоб нашудааст";
var moveUp = "Ба боло ҳаракат кунед";
var moveDown = "Ба поён ҳаракат кунед";
var isLoading = "Дар ҳоли боргузорӣ";
var loadMore = "Бештар бор кунед";
var next = "Баъдӣ";
var prev = "Гузашта";
var addAllValues = "Ҳама арзишҳоро илова кунед";
var addSelectedValues = "Илова кардани арзишҳои интихобшуда";
var removeAllValues = "Ҳама арзишҳоро хориҷ кунед";
var removeSelectedValues = "Арзишҳои интихобшударо хориҷ кунед";
var chooseDate = "Сана интихоб кунед";
var changeDate = "Тағйир додани сана";
var accepted = function({
  name
}) {
  return `Лутфан ${name}-ро қабул кунед`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} бояд пас аз ${date(args[0])} бошад.`;
  }
  return `${sentence(name)} бояд дар оянда бошад.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} метавонад танҳо аломатҳои алифборо дар бар гирад.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} метавонад танҳо ҳарфҳо ва рақамҳоро дар бар гирад.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} метавонад танҳо ҳарфҳо ва фосилаҳоро дар бар гирад.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} must contain alphabetical characters.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} must contain letters and numbers.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} must contain letters and spaces.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} must contain symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} must contain uppercase.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} must contain lowercase.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} must contain number.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} can only contain symbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} can only contain uppercase.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} can only contain lowercase.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} бояд пеш аз ${date(args[0])} бошад.`;
  }
  return `${sentence(name)} бояд дар гузашта бошад.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Ин майдон нодуруст танзим шудааст ва онро пешниҳод кардан ғайриимкон аст.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} бояд дар байни ${a} ва ${b} бошад.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} мувофиқат намекунад.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} санаи дуруст нест, лутфан формати ${args[0]}-ро истифода баред`;
  }
  return "Ин майдон нодуруст танзим шудааст ва онро пешниҳод кардан ғайриимкон аст";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} бояд дар байни ${date(args[0])} ва ${date(args[1])} бошад`;
};
var email = "Лутфан нишонаи имейли амалкунандаро ворид намоед.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} бо ${list(args)} ба охир намерасад.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} арзиши иҷозатдодашуда нест.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} бояд ҳадди аққал як аломат бошад.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} бояд аз ${max2} аломат камтар ё баробар бошад.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} бояд ${max2} аломат бошад.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} бояд аз ${min2} аломат зиёд ё баробар бошад.`;
  }
  return `${sentence(name)} бояд дар байни ${min2} ва ${max2} аломат бошад.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} арзиши иҷозатдодашуда нест.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Зиёда аз ${args[0]} ${name} дошта наметавонад.`;
  }
  return `${sentence(name)} бояд аз ${args[0]} камтар ё баробар бошад.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Ягон формати файл иҷозат дода намешавад.";
  }
  return `${sentence(name)} бояд чунин намуд бошад: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Камтар аз ${args[0]} ${name} дошта наметавонад.`;
  }
  return `${sentence(name)} бояд ҳадди аққал ${args[0]} бошад.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}" ${name} иҷозат дода намешавад.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} бояд рақам бошад.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" ё ")} зарур а`;
};
var required = function({
  name
}) {
  return `${sentence(name)} лозим аст.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} бо ${list(args)} оғоз намешавад.`;
};
var url = function() {
  return `Лутфан URL-и дурустро дохил кунед.`;
};
var invalidDate = "Санаи интихобшуда нодуруст аст.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var tg_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, tg_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=tg.mjs.map